/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ContactRateCard_rateCardItem = {
    readonly title: string;
    readonly keyFields: ReadonlyArray<{
        readonly key: string;
        readonly " $fragmentRefs": FragmentRefs<"KeyField_data">;
    }> | null;
    readonly " $refType": "ContactRateCard_rateCardItem";
};
export type ContactRateCard_rateCardItem$data = ContactRateCard_rateCardItem;
export type ContactRateCard_rateCardItem$key = {
    readonly " $data"?: ContactRateCard_rateCardItem$data;
    readonly " $fragmentRefs": FragmentRefs<"ContactRateCard_rateCardItem">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactRateCard_rateCardItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyField",
      "kind": "LinkedField",
      "name": "keyFields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "KeyField_data"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SettingsItem",
  "abstractKey": null
};
(node as any).hash = '8e546cc44ac46c86607fdcd54c9bacaf';
export default node;
